@if (cancelConfirmationVm$ | async; as meetingDetails) {
<div class="container main-container">
  <div class="meeting-info-header">
    <img
      src="/assets/images/confirm-tick.svg"
      alt="Cancelled"
      class="confirm-icon"
    />
    <p class="header-text" i18n="@@CANCELLED_INFO.TITLE">
      {{ 'CANCELLED_INFO.TITLE' | translate }}
    </p>
    <p
      class="secondary-text-color subtitle-text"
      i18n="@@CANCELLED_INFO.SUBTITLE"
    >
      {{ 'CANCELLED_INFO.SUBTITLE' | translate }}
    </p>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">person</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.DETAILS">
        {{ 'CANCEL_INFO.DETAILS' | translate }}
      </div>
    </div>
    <div class="component-body profile-backdrop">
      <p class="primary-text">{{ meetingDetails.displayTitle }}</p>
      <p class="secondary-text-color">
        with {{ meetingDetails.hostNamesText }}
      </p>
    </div>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">today</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.WHEN">
        {{ 'CANCEL_INFO.WHEN' | translate }}
      </div>
    </div>
    <div class="component-body calendar-backdrop">
      <p class="primary-text strikethrough">{{ meetingDetails.dateText }}</p>
      <div class="secondary-text-color strikethrough">
        {{ meetingDetails.timeRangeText }} {{ meetingDetails.timezoneZoneText }}
      </div>
    </div>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">location_on</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.WHERE">
        {{ 'CANCEL_INFO.WHERE' | translate }}
      </div>
    </div>
    @if (meetingDetails.isInPerson) {
    <div class="component-body location-backdrop location-centered">
      <span class="primary-text capitalize-first strikethrough">{{
        meetingDetails.meetingInfo.location
      }}</span>
    </div>
    } @if (!meetingDetails.isInPerson) {
    <div
      class="component-body secondary-text-color location-backdrop location-centered"
    >
      <span i18n="@@CANCEL_INFO.ONLINE_APPOINTMENT">{{
        'CANCEL_INFO.ONLINE_APPOINTMENT' | translate
      }}</span>
    </div>
    }
  </div>
  @if (meetingDetails.bookingUrl) {
  <div class="section-gap-lg flex-row-center">
    <span i18n="@@CANCELLED_INFO.NEED_TO_BOOK">{{
      'CANCELLED_INFO.NEED_TO_BOOK' | translate
    }}</span>
    <a
      class="book-now-link"
      (click)="bookNow(meetingDetails.bookingUrl)"
      i18n="@@CANCELLED_INFO.BOOK_NOW"
    >
      {{ 'CANCELLED_INFO.BOOK_NOW' | translate }}
    </a>
  </div>
  }
  @if (meetingDetails.meetingInfo.businessLogo) {
  <div class="section-gap-sm logo-container">
    <img
      [src]="meetingDetails.meetingInfo.businessLogo"
      alt="Business Logo"
      class="business-logo"
    />
  </div>
  }
</div>
} @else {
<div class="row row-gutters">
  @for (i of [].constructor(6); track i) {
  <div class="col col-xs-12 col-sm-6">
    <div class="stencil-shimmer meeting-type-card">
      <div
        class="meeting-type-icon mat-elevation-z2 stencil-shimmer disappear-on-mobile"
      ></div>
    </div>
  </div>
  }
</div>
}
